import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, Badge, Tooltip, OverlayTrigger, Dropdown, Popover,  Row, Col, Tab, Nav  } from "react-bootstrap";
import Drawer from '@mui/material/Drawer';
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import DatePicker from "react-multi-date-picker";

import csv_ico from '../../../../images/export_icons/csv.ico';
import excel_ico from '../../../../images/export_icons/excel.ico';
import print_ico from '../../../../images/export_icons/print.ico';
import new_gif from '../../../../images/new_subs.gif';

import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const InternalCall = () => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [total_entries, setTotslEntries] = useState(0);
    const [verified, setverified] = useState(0);
    const [unverified, setunverified] = useState(0);

    const [total_lead, setTotalLead] = useState(0);
    const [total_spam, setTotalSpam] = useState(0);
    const [total_dead, setTotalDead] = useState(0);
    const [total_call, settotalCall] = useState(0);
    const [total_followup, setTotalfollowup] = useState(0);

    useEffect (() => {
        axios.get(`${baseURL}/lead/counts`)
            .then(response => {
            setTotalLead(response.data.lead);
            setTotalSpam(response.data.spam);
            setTotalDead(response.data.dead);
            setTotalfollowup(response.data.today_followup_count);
            settotalCall(response.data.internal_call);
            })
            .catch(error => {
            console.error('There was an error fetching the posts!', error);
            });
    }, []);

    // page table data fetch
    const fetchData = (filter = {}) => {
        const params = {
            ...filter,      // spread existing filter key-values
            page,           // add page number
            per_page: perPage, // add per_page
            search: searchTerm  // add search string
        };
        axios.get(`${baseURL}/lead/internal_call`, { params: params })
            .then(response => {
                setData(response.data.data);
                setHasFetched(true);
                setTotalPages(response.data.last_page);
                setTotslEntries(response.data.total);
                setverified(response.data.verified);
                setunverified(response.data.not_verified);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            });
    };

    // fetch data & leadstatus
    useEffect(() => {
        fetchData();
    }, [page, searchTerm, perPage]);

    const tableRef = useRef(null);

    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);


    const handleModalTogglespam = (id, data) => {
        // Generate options dynamically
        
        swal.fire({
            html: `
                <div class="alert alert-info px-2 py-2" role="alert">
                    Are you sure want to approve this lead as Internal Call?
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <div class="row mb-2 text-center">
                    <label class="text-black font-w300"><b>${data.lead_name} - ${data.lead_mobile}</b></label>
                </div>
                <div class="text-center mt-4 mb-3">
                    <label class="fw-bold text-green fs-2">Approve</label>
                </div>
                <div class="form-group text-start mt-3">
                    <label for="reasonSelect" class="form-label">Enter Reason<span class="required">*</span></label>
                   <input type="text" id="reasonInput" class="form-control" placeholder="Enter reason here">
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-success',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,

            preConfirm: () => {
                const reason = document.getElementById('reasonInput').value;
                if (!reason) {
                    swal.showValidationMessage('Please Enter a reason');
                    return false;
                }
                return { reason };
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                axios.put(`${baseURL}/lead/update_call/${data.sno}`, {
                    status: id,
                    verification_reason: result.value.reason
                })
                .then((result) => {
                    // window.location.reload();
                    fetchData();
                    toast.success("Internal Call Approved Successfully!");
                })
                .catch(error => {
                    console.log(error);
                    toast.error("Internal Call Approval Failed");
                });
            }
        });
    };

    const handleModalToggleReject = (id, data) => {
        // Generate options dynamically
        
        swal.fire({
            html: `
                <div class="alert alert-info px-2 py-2" role="alert">
                    Are you sure want to reject this lead as Internal call ?
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <div class="row mb-2 text-center">
                    <label class="text-black font-w300"><b>${data.lead_name} - ${data.lead_mobile}</b></label>
                </div>
                <div class="text-center mt-4 mb-3">
                    <label class="fw-bold text-red fs-2">Reject</label>
                </div>
                <div class="form-group text-start mt-3">
                    <label for="reasonSelect" class="form-label">Enter Reason<span class="required">*</span></label>
                   <input type="text" id="reasonInput" class="form-control" placeholder="Enter reason here">
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-success',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,

            preConfirm: () => {
                const reason = document.getElementById('reasonInput').value;
                if (!reason) {
                    swal.showValidationMessage('Please Enter a reason');
                    return false;
                }
                return { reason };
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                axios.put(`${baseURL}/lead/update_call/${data.sno}`, {
                    status: id,
                    verification_reason: result.value.reason
                })
                .then((result) => {
                    // window.location.reload();
                    fetchData();
                    toast.success("Internal Call rejected Successfully!");
                })
                .catch(error => {
                    console.log(error);
                    toast.error("Internal Call Rejection Failed");
                });
            }
        });
    };

    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    pageLength: 25,
                    //   "aaSorting": [],
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);

    const [key, setKey] = useState('call');

    return (
        <>
            <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Manage Lead</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Lead Management</li>
                    </ol>
                </div>
                
                
            </div>

            <Col xl={12} className='mb-3'>
                <div className="custom-tab-1">
                    <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                        <Nav as="ul" className="nav-tabs">
                            <Nav.Item as="li" >
                                <Nav.Link as={Link} to="/manage-lead">
                                    <i class="fa-solid fa-users"></i>
                                    <label className="ms-2 fs-6">
                                        Lead
                                    </label>
                                    <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                       {total_lead}
                                    </Badge>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link as={Link} to="/manage-spam-lead">
                                    <i class="fa-solid fa-users-slash"></i>
                                    <label className="ms-2 fs-6">
                                        Spam Lead
                                    </label>
                                    <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                        {/* {responses.closed_followup_count} */}
                                        {total_spam}
                                    </Badge>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link as={Link} to="/manage-dead-lead">
                                    <i class="fa-solid fa-users-rays"></i>
                                    <label className="ms-2 fs-6">
                                        Dead Lead
                                    </label>
                                    <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                        {/* {responses.reschedule_followup_count} */}
                                        {total_dead}
                                    </Badge>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="call">
                                    <i class="fa-solid fa-calendar-day"></i>
                                    <label className="ms-2 fs-6">
                                        Internal Call
                                    </label>
                                    <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                        {/* {responses.unfollowup_count} */}
                                        {total_call}
                                    </Badge>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link as={Link} to="/manage-today-followup">
                                    <i class="fa-solid fa-calendar-xmark"></i>
                                    <label className="ms-2 fs-6">
                                        Today Followup
                                    </label>
                                    <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                        {/* {responses.unfollowup_count} */}
                                        {total_followup}
                                    </Badge>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </Tab.Container>
                </div>
            </Col>

            <div className='row mb-3'>
                <div className='d-flex align-items-end justify-content-end'>
                    {/* <div className="me-2">
                        <div className="border rounded px-3 py-1 border-info bg-info-light">
                        <label className="text-black fs-6">Waiting</label>
                        <div className="d-block text-center">
                            <label className="text-danger fs-3 m-0 fw-bold">
                            <span>00</span>
                            </label>
                        </div>
                        </div>
                    </div> */}
                    <div className='me-2'>
                        <div className='border rounded px-3 py-1 border-success bg-success-light'>
                            <label className='text-black fs-6'>Approved</label>
                            <div className='d-block text-center'>
                                <label className="text-danger fs-3 m-0 fw-bold">
                                    {/* <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span> */}
                                    <span>{verified}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className='me-2'>
                        <div className='border rounded px-3 py-1 border-danger bg-danger-light '>
                            <label className='text-black fs-6'>Rejected</label>
                            <div className='d-block text-center'>
                                <label className="text-danger fs-3 m-0 fw-bold">
                                    {/* <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span> */}
                                    <span>{unverified}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>


            <div className="table-container">

                <div className="d-flex justify-content-between align-items-center mb-3">
                    {/* Left: Show entries dropdown */}
                    <div>
                        <label className="me-2">Show</label>
                        <select
                            className="form-select d-inline w-auto"
                            style={{  fontSize: '0.85rem', height: '30px' }}
                            value={perPage}
                            onChange={(e) => {
                                setPerPage(Number(e.target.value));
                                setPage(1); // Reset to first page
                            }}
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                    </div>

                    {/* Right: Search input */}
                    <div>
                        <input
                            type="text"
                            style={{  fontSize: '0.85rem', height: '40px' }}
                            placeholder="Search..."
                            className="form-control"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setPage(1); // Reset page on new search
                            }}
                        />
                    </div>
                </div>

                <table  className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd' }}>
                    <thead>
                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head align-top">
                            <th className='min-w-100px'>Lead</th>
                            <th className='min-w-100px text-start'>Mobile Number</th>
                            <th className='min-w-80px text-start'>Sales Person</th>
                            <th className='min-w-50px text-start'>Reason</th>
                            <th className='min-w-50px text-center'>Status</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7 align-top">
                        {datas.length === 0 && hasFetched ? (
                            <tr>
                                <td colSpan="5" className="text-center text-muted py-2">
                                    No data available
                                </td>
                            </tr>
                        ) : (
                            <>
                                {datas.map((data, index) => (
                                <tr key={data.sno}>
                                    <td>
                                        <div className='text-black font-w400 fs-7 text-wrap mw-75'>{data.lead_name}</div>
                                    </td>
                                    <td className='text-start'>
                                        <div className='text-black font-w400 fs-7 text-wrap mw-75'>{data.lead_mobile}</div>
                                    </td>
                                    <td className='text-start'>
                                        <div className='text-black font-w400 fs-7 text-wrap mw-75'>{data.sales_person}</div>
                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Lead Source</span></Tooltip>} >
                                            <div className='text-info font-w600 fs-8 text-wrap mw-75'>{data.lead_sources_name}</div>
                                        </OverlayTrigger>
                                    </td>
                                    <td className='text-start'>
                                        <div class="text-truncate max-w-200px text-black fw-semibold fs-7">{data.conversion_reason ? data.conversion_reason : '-'}</div> 
                                        {data.verification_reason && (
                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>{data.verification_reason}</span></Tooltip>} >
                                                <div className='text-truncate mw-300px text-dark font-w400 fs-7'>[ {data.verification_reason} ]</div>
                                            </OverlayTrigger>  
                                        )}        
                                    </td>
                                    <td className='text-center'>
                                        {data.status === 0 ? (
                                        <Dropdown drop="">
                                            <Dropdown.Toggle as="a" className={`i-false cursor-pointer`}
                                            >  <Badge bg="none" className='py-1 px-2 fs-8 text-black' style={{ background: '#f4d03f' }}>Waiting for Approval</Badge>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu >
                                                <Dropdown.Item href="#" className='text-black' onClick={() => handleModalTogglespam(1,data)}>Approve</Dropdown.Item>
                                                <Dropdown.Item href="#" className='text-black' onClick={() => handleModalToggleReject(2,data)}>Reject</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                        ) : (
                                            <>
                                                {data.status === 1 ? (
                                                    <Badge bg="success" className='py-1 px-2 fs-8 text-white'>Approved</Badge>
                                                ) : (
                                                    <Badge bg="danger" className='py-1 px-2 fs-8 text-white'>Rejected</Badge>
                                                )}
                                            </>
                                        )}
                                    </td>
                                </tr>
                                ))}
                            </>
                        )}
                    </tbody>
                </table>

                <div className="d-flex justify-content-between align-items-center mt-3">
                    {/* Bottom left: Showing x to y of z entries */}
                    <div>
                        {datas.length > 0 ? (
                            <span className="text-muted">
                                Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {total_entries} entries
                            </span>
                        ):(
                            <span className="text-muted">
                                Showing 0 to 0 of 0 entries
                            </span>
                        )}
                    </div>

                    {/* Bottom right: Pagination */}
                    <nav>
                        <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                            </li>
                            {[...Array(totalPages)].map((_, i) => (
                            <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                            </li>
                            ))}
                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                            </li>
                        </ul>
                    </nav>

                </div>

            </div>


        </>
    )


}

export default InternalCall;